import { render, staticRenderFns } from "./DevolutionsLarge.vue?vue&type=template&id=3cf62bc3&"
import script from "./DevolutionsLarge.vue?vue&type=script&lang=js&"
export * from "./DevolutionsLarge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports